import { CustomElement, resolve } from 'aurelia';
import { CalendarService } from '../../services';
import template from './calendar-grid.html';

// The center panel: the month navigation (prev/next + month picker) and the day grid. Selecting
// a day opens the releases panel. All state and actions live in CalendarService. The admin
// diagnostics log is composed below the grid as its own <admin-log> component.
export class CalendarGridElement {
  readonly calendar: CalendarService = resolve(CalendarService);
}

export const CalendarGrid = CustomElement.define({
  name: 'calendar-grid',
  template,
  // Render the <section> in place (no host wrapper) so it stays a direct grid child of .main-layout.
  containerless: true
}, CalendarGridElement);
